import React from 'react'
import { PartnerWithUs } from '../../src/components'
import Footers from '../../src/components/Footer'
import Header from '../../src/components/Header'

export default function PartnerWithUsPage() {
  return (
    <>
      <Header />
      <div className="cure-inner-container">
        <PartnerWithUs />
      </div>
      <Footers />
    </>
  )
}
